
import bg_pc from 'images/pc_bg.jpg'
import menu_bg from 'images/menu_bg.jpg'
import menu_logo from 'images/menu_logo.png'
import magnifier from 'images/magnifier.png'
import menu_star from 'images/menu_star.png'
import menu_btn from 'images/menu_btn.png'
import bg_deco from 'images/bg_deco.png'

import { useLocation, useNavigate, useSearchParams, } from 'react-router-dom'
import { useContext, useEffect } from 'react'
import { cls, CustomContext, useSyncState } from 'pages/Root'
import Spinner from './Spinner'
import Drawer from './Drawer'

export const DATA_SOURCE =process.env.NODE_ENV==='production'?'https://flyff.94hi.net/data/guide.json':'/proxy/data/guide.json'

function RootFrame({children}){
  const searchParams =useSearchParams()
  const location =useLocation()
  const navigate =useNavigate()

  const customData =useContext(CustomContext)
  const loadingData =useSyncState(undefined)

  var search_keyword =useSyncState('') //useSyncState('')

  // const currCategory =useSyncState(undefined)

// Function to strip HTML tags and search for keyword
  const searchInHtmlContent = (html, searchKeyword) => {
    // Escape special regex characters in the search keyword
    const escapeRegExp = (string) => {
      return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // Escapes special characters
    };

    // Create a temporary DOM element to strip HTML tags
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;
    const plainText = tempDiv.textContent || tempDiv.innerText; // Get plain text

    // Perform case-insensitive keyword search
    const regex = new RegExp(escapeRegExp(searchKeyword), 'i'); // 'i' for case-insensitive
    const isFound = plainText.search(regex) !== -1;

    // Find all matches for detailed results
    const matches = plainText.match(new RegExp(escapeRegExp(searchKeyword), 'ig')) || [];
    
    return {
      plainText,
      isFound,
      matches,
      matchCount: matches.length,
    };
  };

  const _impl_search =(e)=>{
    console.log('27 - _impl_search(), kw='+search_keyword[2].current)
    if (customData.manualData[2].current ===undefined){
      return
    }

    var search_category ={
      name: `搜尋`,
      list: []
    }
    for(var i=0;i<customData.manualData[2].current.length;++i){
      for(var j=0;j<customData.manualData[2].current[i].list.length;++j){
        if (customData.manualData[2].current[i].list[j].name.indexOf(search_keyword[2].current)!==-1 ||
            searchInHtmlContent(customData.manualData[2].current[i].list[j].html, search_keyword[2].current).isFound){

          if (customData.manualData[2].current[i].list[j].public||searchParams[0].get('admin')==='1'){
            search_category.list.push(
              structuredClone(customData.manualData[2].current[i].list[j])
            )
          }
          
        }
      }
      
    }

    customData.filteredManualData[1](search_category)

    //需要修改 type 嗎?
    var nav =`?type=搜尋&filter=${encodeURIComponent(search_keyword[2].current)}`

    console.log('87 - change type from '+searchParams[0].get('type')+' --> 搜尋')
    if (searchParams[0].has('admin')){
      nav+='&admin='+searchParams[0].get('admin')
    }

    console.log('99 - set navigate to '+nav)
    return nav
  }

  const search_box_onchange =(e)=>{
    if (customData.manualData[2].current ===undefined){
      return
    }

    search_keyword[1](e.target.value)

    //
    var nav =_impl_search()

    customData.currCategory[1]('搜尋')
    console.log('114 - navigate to '+nav)
    navigate(nav)
  }

  const fetchManualData =async ()=>{
    try{
      const response =await fetch(`${DATA_SOURCE}`, {
        method: 'GET',
      })

      if (!response.ok){
        let body;
        try {
          body = await response.json();
        } catch {
          body = { msg: 'Unknown error occurred' };
        }
      
        const errorContext = {
          status: response.status,
          body: body.msg || 'Request failed',
        };
        
        throw new Error(JSON.stringify(errorContext));
        
      }else{
        const resolved_data =await response.json()
        console.log('588 - manual data :', resolved_data)

        customData.manualData[1](resolved_data)  
        
        
      }
    }catch(error){
      let errorObj;
      try {
        errorObj = JSON.parse(error.message);
      } catch {
        errorObj = { body: 'Unexpected error occurred', status: 400 };
      }

    }
  }

  const getPortraitMode =()=>{
    return 'portraitMode'
  }

  useEffect(()=>{
    var _impl =async ()=>{
      if (loadingData[2].current ===undefined){
        loadingData[1](true)
        await fetchManualData()

        if (customData.manualData[2].current){
          loadingData[1](false)
        }
      }
    }

    _impl()

  },[])

  useEffect(()=>{
    if (loadingData[0]!==false || customData.manualData[2].current ===undefined){
      return
    }

    var menu_list_arr =[]
    customData.manualData[2].current?.filter(v=>v.list?.some(vs=>vs.public||searchParams[0].get('admin')==='1'))?.map(v=>{
      menu_list_arr.push(v.name)
    })
    var menu_list_set =new Set(menu_list_arr)

    console.warn('89 - selected category =', searchParams[0].get('type'))

    if (searchParams[0].has('type')===false && menu_list_arr.length>0){
      var nav =`?type=${menu_list_arr[0]}`
      if (searchParams[0].has('admin')){
        nav+='&admin='+searchParams[0].get('admin')
      }
      navigate(nav)
      return
    }

    if ( searchParams[0].has('type') && (menu_list_set.has(searchParams[0].get('type'))||searchParams[0].get('type')==='搜尋') ){
      customData.currCategory[1](searchParams[0].get('type'))
      console.log('105 - curr category set to '+customData.currCategory[2].current)

      if (searchParams[0].has('filter')&&(searchParams[0].get('filter').length>0||searchParams[0].get('type')==='搜尋')){
        search_keyword[1](searchParams[0].get('filter'))
        var nav =_impl_search()
        //navigate(nav)
      }

    }
  },[loadingData[0], location])

  return (
    <div className=" overflow-x-hidden w-[100vw] h-[calc(100*var(--vh))] bg-cover MQ-PCP:bg-center row items-center justify-center MQ-PCP:space-x-[10px]" style={{backgroundImage: `url(${bg_pc})`}}>
      <nav className="hidden MQ-PCP:flex col-auto [&&]:w-[250px] h-[900px] max-h-[95%] bg-[#54bbed] border-white border-[2px] rounded-[20px] ring-[2px] ring-[#76cdf5] bg-contain bg-no-repeat column items-center" style={{backgroundImage: `url(${menu_bg})`}}>
        <button className="my-[16px] h-[75px] w-[162px]" onClick={(e)=>{
          search_keyword[1]('')
          customData.filteredManualData[1](undefined)
          navigate('')
        }}>
          <img src={menu_logo}/>
        </button>
        <div className="w-[calc(100%-30px)] h-[38px] bg-[#fcfeff] rounded-[19px] row items-center px-[20px]" style={{filter: 'drop-shadow(0px 2px 2px #ffffff80) drop-shadow(0px -2px 2px #bad0db)'}}>
          <div className="col-auto w-[20px] h-[20px]">
            <img src={magnifier}/>
          </div>
          <input disabled={customData.manualData[2].current ===undefined} className="bg-[#fcfeff] w-full h-full focus:outline-none pl-[10px] text-[15px] text-[#7a7a7a] placeholder-[#d0d0d0]" placeholder="點此搜尋" value={search_keyword[0]} onChange={search_box_onchange}></input>
        </div>
        <div className="col bg-[#fcfcfc] w-[calc(100%-12px)] mt-[12px] m-[6px] rounded-[15px] column overflow-hidden">
          {loadingData[0]&&<div className="col-auto w-full [&&]:h-[80px] row items-center justify-center">
            <Spinner className="w-[30px]" thumbColor="text-[#7a7a7a]"/>
          </div>}
          <div className="col-auto column overflow-auto">
          {customData.manualData[0]&&[...(customData.filteredManualData[0]?[customData.filteredManualData[0]]:[]), ...customData.manualData[0].filter(v=>v.list?.some(vs=>vs.public||searchParams[0].get('admin')==='1'))]?.map((v,idx)=>{
            var active =customData.currCategory[0]===v.name
            return <button key={idx} className="col-auto [&&]:h-[80px] w-full column group" onClick={(e)=>{
              var nav_str =`?type=${v.name}`
              if (searchParams[0].has('filter')){
                nav_str+='&filter='+encodeURIComponent(search_keyword[2].current)
              }
              if (searchParams[0].has('admin')){
                nav_str+='&admin='+searchParams[0].get('admin')
              }
              if (searchParams[0].has('type')&&searchParams[0].get('type')===v.name){
                //navigate to the same category
                // console.log('74 -', customData.parentHtmlRef)
                customData.parentHtmlRef.current?.scrollTo(0, 0)
              }else{
                navigate(nav_str)
              }
            }}>
              <div className="col row w-full items-center">
                <div className={cls("col-auto h-[38px] [&&]:w-[calc(100%-20px)] ml-[10px] rounded-[19px] row items-center justify-between px-[20px] group-hover:bg-gradient-to-r group-hover:from-[#47bff4]", active&&"bg-gradient-to-r from-[#47bff4]")}>
                  <label className={cls(" pointer-events-none text-[20px] font-bold group-hover:text-white truncate", active?"text-white":"text-[#47bff4]")}>{(v.name==='搜尋'&&search_keyword[0])?`搜尋 : ${search_keyword[0]}`:v.name}</label>
                  <img className={cls("group-hover:opacity-100", active?"opacity-100":"opacity-0")} src={menu_star}/>
                </div>
              </div>
              <div className="col-auto w-[calc(100%-60px)] [&&]:h-[2px] bg-[#d8effb] ml-[30px]"/>
            </button>
          })}
          </div>
        </div>
      </nav>
      <div className={cls(
        "col column",
        "[&&]:max-w-[95%] MQ-PCP:[&&]:min-w-[550px] MQ-PCP:[&&]:max-w-[940px] h-full max-h-[97%] MQ-PCP:h-[900px] MQ-PCP:max-h-[95%]"
      )}>
        <div className="row items-center MQ-PCP:hidden ">
          <nav className={cls(
            "col",
            "bg-gradient-to-b from-[#85d8fa] to-[#54bbed] border-white border-[2px] rounded-[15px] ring-[2px] ring-[#76cdf5] column overflow-hidden",
            "[&&]:h-[50px] mb-[10px] row items-center justify-center"
          )}>
            <div className="w-[calc(100%-30px)] h-[30px] bg-[#fcfeff] rounded-[19px] row items-center px-[20px]" style={{filter: 'drop-shadow(0px 2px 2px #ffffff80) drop-shadow(0px -2px 2px #bad0db)'}}>
              <div className="col-auto w-[20px] h-[20px]">
                <img src={magnifier}/>
              </div>
              <input disabled={customData.manualData[2].current ===undefined} className="bg-[#fcfeff] w-full h-full focus:outline-none pl-[10px] text-[15px] text-[#7a7a7a] placeholder-[#d0d0d0]" placeholder="點此搜尋" value={search_keyword[0]} onChange={search_box_onchange}></input>
            </div>
          </nav>
          <button className="w-[45px] h-[51px] mb-[10px] pl-[10px] focus:outline-none" onClick={(e)=>{
            customData['drawerState'][1](!customData['drawerState'][2].current)
          }}>
            <img src={menu_btn}/>
          </button>
        </div>
        <div className={cls(
          "relative",
          "col bg-[#fcfcfc] border-white border-[2px] rounded-[15px] MQ-PCP:rounded-[20px] ring-[2px] ring-[#76cdf5] column overflow-hidden",
        )}>
          <div className="absolute left-0 bottom-0">
            <img src={bg_deco}/>
          </div>
          <div className='relative col-auto [&&]:h-[46px] MQ-PCP:[&&]:h-[58px] bg-gradient-to-b from-[#85d8fa] to-[#54bbed] row items-center justify-center'>
            <h1 className="text-white text-[20px] MQ-PCP:text-[25px] font-bold truncate max-w-[90%]">{customData.currCategory[0]==='搜尋'?`搜尋 : ${search_keyword[0]}`:customData.currCategory[0]}</h1>
          </div>
          <div ref={customData.parentHtmlRef} className="relative col overflow-y-scroll">{children}</div>
        </div>
      </div>
      {customData[getPortraitMode()][0]&&<Drawer />}
    </div>
  )
}

export default RootFrame